/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reason: NonNullable<unknown> }} Ebr_Skipped_ReasonInputs */

const cs_ebr_skipped_reason = /** @type {(inputs: Ebr_Skipped_ReasonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Přeskočeno: ${i?.reason}`)
};

const en_ebr_skipped_reason = /** @type {(inputs: Ebr_Skipped_ReasonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Skipped: ${i?.reason}`)
};

/**
* | output |
* | --- |
* | "Skipped: {reason}" |
*
* @param {Ebr_Skipped_ReasonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_skipped_reason = /** @type {((inputs: Ebr_Skipped_ReasonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Skipped_ReasonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_skipped_reason(inputs)
	return cs_ebr_skipped_reason(inputs)
});